/** @jsxImportSource @emotion/react */

import { Dispatch, FC, SetStateAction } from 'react'
import { findAllFlashCardGroup_findAllFlashCardGroup_items as IGroup } from '__generatedTypes__/findAllFlashCardGroup'
import { SubjectExtendedFull } from 'hooks/usePlatformsAndSubjects'
import FlashCardsGroups from './FlashCardsGroups'
import FlashCardsTabs from './FlashCardsTabs'

interface IProps {
  selectedSubject: SubjectExtendedFull
  groups: IGroup[]
  setGroups: Dispatch<SetStateAction<IGroup[]>>
}

const FlashCardsContent: FC<IProps> = ({ selectedSubject, groups, setGroups }) => (
  <>
    <FlashCardsGroups groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    {groups.length > 0 && (
      <FlashCardsTabs groups={groups} selectedSubjectId={selectedSubject.id} initialSelected={groups[0]} />
    )}
  </>
)

export default FlashCardsContent
